import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, EventEmitter, Output } from '@angular/core';

import { snSlideInUp, snSlideOutUp } from '@lib/common/animations';
import { SnActionConfig } from '@lib/ui/actions';

@Component({
  selector: 'sn-selection-bar',
  templateUrl: './selection-bar.component.html',
  styleUrls: ['./selection-bar.component.scss'],
  animations: [snSlideInUp, snSlideOutUp],
})
export class SelectionBarComponent {
  @Input()
  public selection: SelectionModel<any>;

  @Input()
  public readonly actions: SnActionConfig[] = [];

  @Output()
  public readonly deselect = new EventEmitter<SelectionModel<any>>();

  constructor() {}

  public deselectAll(): void {
    this.selection.clear();
    this.deselect.next(this.selection);
  }
}
